// extracted by mini-css-extract-plugin
export var actions = "_94-8";
export var arrow = "_94-5";
export var card = "_94-0";
export var cardWrapper = "_94-9";
export var fieldName = "_94-3";
export var newValue = "_94-6";
export var oldValue = "_94-4";
export var orangeGlowFade = "_94-c";
export var productSection = "_94-1";
export var scrollToBottom = "_94-b";
export var scrollToBottomAnchor = "_94-a";
export var scrollToBottomIcon = "_94-d";
export var showAllButton = "_94-7";
export var table = "_94-2";